import { FunctionComponent } from 'react'

import { Button } from '@mapped/rivet/dist/mui/material'
import { styled } from '@mapped/rivet/dist/mui/styles'
import { EStepToken } from '../../../../types/general'
import GeneratedToken from './generatedToken'

const Step3: FunctionComponent<IStep3Props> = ({
  setCurrentStep,
  newToken,
}) => {
  return (
    <div>
      <p>Tokens you have generated can be used to access the Mapped API.</p>

      <ButtonsContainer>
        <Button onClick={() => setCurrentStep(EStepToken.IDLE)}>
          See All Your Personal Access Tokens
        </Button>
      </ButtonsContainer>

      <div style={{ display: 'block', height: 30 }} />

      <GeneratedToken newToken={newToken} />
    </div>
  )
}

const ButtonsContainer = styled.div`
  margin-top: 36px;
`

export interface IStep3Props {
  setCurrentStep: (step: EStepToken) => void
  newToken: string
}

export default Step3
